'use client';

import { useIsDesktop } from '@/shared-utilities';

import ProjectResponseOpenEndSendComponentDesktop from './project-response-open-end-send-desktop';
import ProjectResponseOpenEndSendComponentMobile from './project-response-open-end-send-mobile';
import { resolveRenderMobileView } from './project-response-open-end-send.helpers';
import { ProjectResponseSendComponentProps } from './project-response-renderer.type';

// sm breakpoint is 640px based on tailwind docs https://tailwindcss.com/docs/responsive-design
const DESKTOP_BREAKPOINT = 640;

export default function ProjectResponseOpenEndSendComponent({
  register,
  onKeyDown,
  isSubmitting,
  value,
  hideNewLineText,
  disabled,
  isConversationOver,
  renderMobileView,
  type,
  isUserVoiceEnabled,
}: ProjectResponseSendComponentProps) {
  const { isDesktop, mounted } = useIsDesktop(DESKTOP_BREAKPOINT);

  const shouldRenderMobileView = resolveRenderMobileView(
    renderMobileView,
    isDesktop || !mounted
  );

  if (shouldRenderMobileView) {
    return (
      <ProjectResponseOpenEndSendComponentMobile
        register={register}
        onKeyDown={onKeyDown}
        isSubmitting={isSubmitting}
        value={value}
        hideNewLineText={hideNewLineText}
        disabled={disabled}
        isConversationOver={isConversationOver}
        renderMobileView={renderMobileView}
        type={type}
        isUserVoiceEnabled={isUserVoiceEnabled}
      />
    );
  }

  return (
    <ProjectResponseOpenEndSendComponentDesktop
      register={register}
      onKeyDown={onKeyDown}
      isSubmitting={isSubmitting}
      value={value}
      hideNewLineText={hideNewLineText}
      disabled={disabled}
      isConversationOver={isConversationOver}
      renderMobileView={renderMobileView}
      type={type}
      isUserVoiceEnabled={isUserVoiceEnabled}
    />
  );
}
